<template>
  <footer class="bg-dark d-flex justify-content-center footer">
    <p class="text-light mt-2 mb-2">© MangoSTEEMS Universe</p>
    <span class="text-light mt-2 mb-2">
      <span class="ml-2"> | </span>
      <a
        href="https://www.iubenda.com/privacy-policy/32601846"
        class="iubenda-nostyle no-brand iubenda-embed 
        text-white"
        title="Privacy Policy "
      >
        <small>{{ $t("privacy-policy") }}</small>
      </a>
      |
      <a
        href="https://www.iubenda.com/privacy-policy/32601846/cookie-policy"
        class="iubenda-nostyle no-brand iubenda-embed text-white"
        title="Cookie Policy "
      >
        <small>{{ $t("cookie-policy") }}</small></a
      >
      |
      <a
        href="https://www.iubenda.com/terms-and-conditions/32601846"
        class="iubenda-nostyle no-brand iubenda-embed text-white"
        title="Terms and Conditions "
        ><small>{{ $t("terms-and-conditions") }}</small></a
      ></span
    >
  </footer>
</template>

<script>
export default {};
</script>

<style></style>
